
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5xTWd", function(module, exports) {

$parcel$export(module.exports, "useCreateSpaceExperiment", () => $c339f8d667855dc1$export$718c8063156c26da);

var $9wGTI = parcelRequire("9wGTI");

var $gTyTP = parcelRequire("gTyTP");
const $c339f8d667855dc1$export$718c8063156c26da = ()=>{
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const isSpaceTypesCreationFlowEnabled = isLivePagesFeatureEnabled || (0, $9wGTI.fg)('space_types_creation_flow');
    return {
        isSpaceTypesCreationFlowEnabled: isSpaceTypesCreationFlowEnabled
    };
};

});

parcelRegister("5rZJf", function(module, exports) {

$parcel$export(module.exports, "SpaceOperationsQuery", () => $8e7057c5d2ae7999$export$636a01496687d185);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $d2LG0.default)`query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id operations{operation targetType}}}`;

});


//# sourceMappingURL=FullPageEditorComponent.c0d6698a.js.map
